import { render } from "./active-volume.vue?vue&type=template&id=ae66b178"
import script from "./active-volume.vue?vue&type=script&lang=js"
export * from "./active-volume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__